export default __webpack_public_path__ + "static/SuisseIntl-ThinItalic-cecb3e41424e0e3ee630ed1698869a51.woff";